import { render, staticRenderFns } from "./QuestionList.vue?vue&type=template&id=5821bf62&scoped=true&"
import script from "./QuestionList.vue?vue&type=script&lang=js&"
export * from "./QuestionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5821bf62",
  null
  
)

export default component.exports